import {INews} from '../../models/News'
import {Locale} from '../config/constants'
import {getGlobalEnv} from './coreUtil'

export const getNewsUrl = (
  locale: Locale, {_id}: INews, isAbsolute: boolean, isAmp: boolean
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}\
/${locale}\
/news\
/${_id}\
${isAmp ? '/amp' : ''}`
